import { Button, IconButton, Typography } from '@mui/material';
import TabContentToolbar from 'pages/common/tabContentToolbar';
import React from 'react';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import ClearIcon from '@mui/icons-material/Clear';
import DeleteIcon from '@mui/icons-material/Delete';
import DriveFileMoveRoundedIcon from '@mui/icons-material/DriveFileMoveRounded';
import EditIcon from '@mui/icons-material/Edit';
import { Shortcut, ShortcutGroup } from '../models';

import '../styles/shortcutsToolbar.sass';

interface IShortcutsToolbarProps {
    selectedShortcuts: Shortcut[];
    selectedShortcutGroups: ShortcutGroup[];
    onClearSelectedShortcuts: () => void;
    onMoveSelectedShortcuts: () => void;
    onSelectedShortcutsStateChange: (newState: boolean) => void;
    onDeleteSelectedShortcuts: () => void;
    onEditSelectedShortcut: () => void;
}

export const ShortcutsToolbar: React.FC<IShortcutsToolbarProps> = ({
    selectedShortcuts,
    selectedShortcutGroups,
    onClearSelectedShortcuts,
    onMoveSelectedShortcuts,
    onSelectedShortcutsStateChange,
    onDeleteSelectedShortcuts,
    onEditSelectedShortcut,
}) => {
    if ((selectedShortcuts === null || selectedShortcuts.length === 0) && (selectedShortcutGroups === null || selectedShortcutGroups.length === 0))
        return <React.Fragment></React.Fragment>;

    const totalSelected = selectedShortcuts.length + selectedShortcutGroups.length;

    const getToolbarIcon = (title: string, icon: React.ReactNode, onClick: () => void): JSX.Element =>
        <Button
            aria-label={title.toLowerCase()}
            color='primary'
            startIcon={icon}
            onClick={onClick}
        >
            {title}
        </Button>;

    const getToolbarActions = (): JSX.Element => {
        if (selectedShortcuts.length === 1 && selectedShortcutGroups.length === 0) {
            return <React.Fragment>
                {getToolbarIcon('Edit', <EditIcon />, onEditSelectedShortcut)}
                {getToolbarIcon('Move shortcut', <DriveFileMoveRoundedIcon />, onMoveSelectedShortcuts)}
                {
                    selectedShortcuts[0].isEnabled 
                        ? getToolbarIcon('Disable', <CancelOutlinedIcon />, () => onSelectedShortcutsStateChange(false))
                        : getToolbarIcon('Enable', <CheckCircleOutlineOutlinedIcon />, () => onSelectedShortcutsStateChange(true))
                }
                {getToolbarIcon('Delete', <DeleteIcon />, onDeleteSelectedShortcuts)}
            </React.Fragment>;
        }
        else if (selectedShortcuts.length === 0 && selectedShortcutGroups.length === 1) {
            return <React.Fragment>
                {getToolbarIcon('Delete', <DeleteIcon />, onDeleteSelectedShortcuts)}
            </React.Fragment>;
        }
        else if (selectedShortcuts.length === 0 && selectedShortcutGroups.length > 1) {
            return <React.Fragment>
                {getToolbarIcon('Delete all', <DeleteIcon />, onDeleteSelectedShortcuts)}
            </React.Fragment>;
        }
        else {
            return <React.Fragment>
                {getToolbarIcon('Move shortcuts', <DriveFileMoveRoundedIcon />, onMoveSelectedShortcuts)}
                {getToolbarIcon('Enable all', <CheckCircleOutlineOutlinedIcon />, () => onSelectedShortcutsStateChange(true))}
                {getToolbarIcon('Disable all', <CancelOutlinedIcon />, () => onSelectedShortcutsStateChange(false))}
                {getToolbarIcon('Delete all', <DeleteIcon />, onDeleteSelectedShortcuts)}
            </React.Fragment>;
        }
    }

    return <TabContentToolbar
        toolBarStyles={{
            boxShadow: '0px 3px 3px rgba(0, 0, 0, 0.10588235294117647)',
            marginLeft: '-16px',
            width: '102%',
        }}
    >
        <div className="shortcuts-toolbar-selected-container">
            <IconButton onClick={onClearSelectedShortcuts} color='primary'>
                <ClearIcon />
            </IconButton>
            <Typography color="primary" className='shortcuts-selected-count'>
                {`${totalSelected} SELECTED`}
            </Typography>
        </div>
        <div>
            {getToolbarActions()}
        </div>
    </TabContentToolbar>;
};